export default "__VITE_ASSET__ChYLX7zX__"